import axios from "axios";
import store from "./store";
import { renewSession } from "./services/AuthService";

const codes = ["TOKEN-1012", "TOKEN-1014", "401"];

axios.interceptors.request.use(
  (config) => {
    const state = store.getState();

    const token = sessionStorage.getItem("access_token");

    // Ensure params object exists
    config.params = { ...(config.params || {}) };

    // organizationIds is now passed explicitly in each service file where the
    // API requires it — do not inject it globally here.
    // const isAZAdmin = !userDetails?.orgId && !userDetails?.orgType;
    // if (!config.params.organizationIds) {
    //   if (isAZAdmin) {
    //     config.params.organizationIds = currentOrgId || 4;
    //   } else if (isPlatformUser) {
    //     const selectedClient = currentOrgId && currentOrgId !== userDetails?.orgId
    //       ? currentOrgId
    //       : null;
    //     if (selectedClient) config.params.organizationIds = selectedClient;
    //   } else {
    //     const orgId = currentOrgId || userDetails?.orgId;
    //     if (orgId) config.params.organizationIds = orgId;
    //   }
    // }

    // ✅ Attach token
    if (token) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${token}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => {
    if (codes.includes(response?.data?.apiStatus?.statusCode)) {
      store.dispatch({
        type: "SET_STATUS_CODE",
        payload: response?.data?.apiStatus?.statusCode,
      });
    } else if (response?.data?.apiStatus?.statusCode === "TOKEN-1013") {
      store.dispatch(renewSession());
    } else {
      const errCode =
        response?.data?.apiStatus?.statusMessage ===
        "Refresh token created successfully"
          ? store.getState().User.statusCode === "401"
            ? "401"
            : null
          : null;

      store.dispatch({
        type: "SET_STATUS_CODE",
        payload: errCode,
      });
    }
    return response;
  },
  (error) => {
    console.warn(error);

    // 👉 Handle 401 fallback (network/auth failure)
    if (error?.response?.status === 401) {
      store.dispatch({
        type: "SET_STATUS_CODE",
        payload: "401",
      });
    }

    return Promise.reject(error);
  },
);
export default axios;
